export const isDemoEnvironment = (): boolean => {
  return window.location.hostname.includes('demo.');
};

export const shouldUseDemoAuth = (): boolean => {
  return isDemoEnvironment() && Boolean(process.env.REACT_APP_DEMO_EMAIL);
};

export const getDemoEmail = (): string => {
  return process.env.REACT_APP_DEMO_EMAIL as string;
};
